import { queryOptions } from "@tanstack/react-query"
import axios from "axios"
import { DataResponse, OutlookIntegrationGenerateAuthUrlResponseDataSchema } from "schema"
import { z } from "zod"

type Response = DataResponse<z.infer<typeof OutlookIntegrationGenerateAuthUrlResponseDataSchema>>

const queryKey = ["generateOutlookAuthLinkQuery"]

export const generateOutlookAuthLinkQuery = () => {
  return queryOptions({
    queryKey,
    queryFn: async () => {
      const response = await axios.get<Response>(`/integrations/outlook/auth`)

      return response.data.data
    },
  })
}
